<template>
  <section
    class="gratuity"
    v-bind:class="{ gratuity__sidebar: location == 'sidebar' }"
    v-if="$store.state.cart.gratuity"
  >
    <h6
      class="gratuity-heading d-none d-md-block"
      v-if="location === 'sidebar'"
    >
      Tip Your Driver
    </h6>
    <form
      @submit.prevent="userChangedCustomAmount"
      v-if="location != 'desktop-footer'"
    >
      <!-- Using anchors because flex button is broken on iOS 9 -->
      <div class="gratuity-options">
        <h6 class="gratuity-heading" v-if="location === 'footer'">
          Tip Your Driver
        </h6>
        <a
          href="#"
          @click.prevent="setGratuityOption('gratuity5', gratuity5.amount)"
          class="gratuity-option btn"
          :class="{ active: isPercent === 5 }"
        >
          <div class="gratuity-percent-label">5%</div>
          <div class="gratuity-dollar-label">
            {{ gratuity5.amount | currency }}
          </div>
        </a>
        <a
          href="#"
          @click.prevent="setGratuityOption('gratuity10', gratuity10.amount)"
          class="gratuity-option btn"
          :class="{ active: isPercent === 10 }"
        >
          <div class="gratuity-percent-label">10%</div>
          <div class="gratuity-dollar-label">
            {{ gratuity10.amount | currency }}
          </div>
        </a>
        <a
          href="#"
          @click.prevent="setGratuityOption('gratuity15', gratuity15.amount)"
          class="gratuity-option btn"
          :class="{ active: isPercent === 15 }"
        >
          <div class="gratuity-percent-label">15%</div>
          <div class="gratuity-dollar-label">
            {{ gratuity15.amount | currency }}
          </div>
        </a>
        <!-- Mobile Gratuity Custom -->
        <label
          @click="setGratuityOption('other')"
          :class="{ active: isCustom }"
          class="gratuity__custom gratuity__custom--footer"
          v-if="location == 'footer'"
        >
          <div
            class="gratuity-percent-label gratuity-custom-label custom-gratuity-label-top"
          >
            Custom Tip
          </div>

          <input
            type="number"
            maxlength="6"
            @keypress="isNumber"
            @blur="userChangedCustomAmount"
            class="gratuity-option gratuity-option--custom"
            v-model="inputBox"
            step="any"
          />
        </label>
      </div>

      <!-- Desktop Sidebar Gratuity Custom -->
      <div class="gratuity-heading">Custom Tip</div>

      <label
        class="gratuity__custom gratuity__custom--sidebar"
        v-if="location == 'sidebar'"
      >
        <div class="gratuity__custom-dollar input-gratuity-custom__dollar">
          $
        </div>
        <input
          type="number"
          maxlength="6"
          @keypress="isNumber"
          @blur="userChangedCustomAmount"
          class="gratuity-option--desktop-custom"
          :class="{ active: isCustom }"
          v-model="inputBox"
          step="any"
        />
      </label>
    </form>

    <!-- Gratuity Dropdown for desktop sticky footer -->
    <form
      v-if="location == 'desktop-footer'"
      @submit.prevent="userChangedCustomAmount"
    >
      <h6 class="gratuity-heading" style="display: inline-block;">
        Tip Your Driver
      </h6>

      <div class="input-gratuity-custom__container">
        <span class="input-gratuity-custom__dollar">$</span>
        <input
          type="number"
          v-model="inputBox"
          class="input-gratuity-custom"
          maxlength="6"
          @keypress="isNumber"
          @blur="userChangedCustomAmount"
          title="Enter a tip for your driver"
          step="any"
        />
      </div>

      <select
        class="select-gratuity-dropdown"
        @change="setGratuityFromDropdown"
      >
        <option value="gratuity5" v-bind:selected="isPercent === 5">5%</option>
        <option value="gratuity10" v-bind:selected="isPercent === 10"
          >10%</option
        >
        <option value="gratuity15" v-bind:selected="isPercent === 15"
          >15%</option
        >
        <option v-bind:value="inputBox" v-bind:selected="isCustom"
          >Other</option
        >
      </select>

      <span v-show="isInvalidTip">
        Not a valid tip. (Tip must be between $0 and $1000.)
      </span>
    </form>

    <div v-show="isInvalidTip" v-if="location == 'footer'">
      Not a valid tip. (Tip must be between $0 and $1000.)
    </div>
  </section>
</template>

<script>
export default {
  name: 'CartGratuity',
  props: {
    cartTotal: {
      type: Number,
      required: true
    },
    location: {
      type: String,
      default: 'sidebar'
    }
  },
  data() {
    return {
      showOther: true,
      selectedOption: 'gratuity5',
      GRATUITY_DEFAULT: '5.00',
      gratuityType: 'PERCENTAGE',
      type: 'PERCENTAGE',
      amount: 0
    };
  },
  computed: {
    gratuity5() {
      return {
        amount:
          Math.round(this.cartTotal * 0.05 * Math.pow(10, 2)) / Math.pow(10, 2),
        formattedAmount:
          Math.round(this.cartTotal * 0.05 * Math.pow(10, 2)) / Math.pow(10, 2)
      };
    },
    gratuity10() {
      return {
        amount:
          Math.round(this.cartTotal * 0.1 * Math.pow(10, 2)) / Math.pow(10, 2),
        formattedAmount:
          Math.round(this.cartTotal * 0.05 * Math.pow(10, 2)) / Math.pow(10, 2)
      };
    },
    gratuity15() {
      return {
        amount:
          Math.round(this.cartTotal * 0.15 * Math.pow(10, 2)) / Math.pow(10, 2),
        formattedAmount:
          Math.round(this.cartTotal * 0.05 * Math.pow(10, 2)) / Math.pow(10, 2)
      };
    },
    inputBox: {
      get() {
        if (typeof this.$store.state.cart.gratuity === 'undefined') {
          return 0; // store is not ready yet
        } else {
          return this.$store.state.cart.gratuity.amount;
        }
      },
      set(value) {
        // manually setting amount since SET_FRONTEND_GRATUITY only sets formatted price and this value is used for calculations
        this.$store.state.cart.gratuity.amount = value;
        this.$store.commit('cart/SET_FRONTEND_GRATUITY', {
          type: 'AMOUNT',
          amount: value * 1
        });
      }
    },
    isInvalidTip() {
      if (this.inputBox > 1000 || this.inputBox < 0) {
        return true;
      } else {
        return false;
      }
    },
    isCustom() {
      if (this.deepFind(this.$store, 'state.cart.gratuity') === undefined) {
        return;
      }

      if (
        this.deepFind(this.$store, 'state.cart.gratuity').hasOwnProperty(
          'percentage'
        )
      ) {
        return false;
      } else {
        return true;
      }
    },
    isPercent() {
      if (this.deepFind(this.$store, 'state.cart.gratuity') === undefined) {
        return;
      }

      if (
        this.deepFind(this.$store, 'state.cart.gratuity').hasOwnProperty(
          'percentage'
        )
      ) {
        return this.$store.state.cart.gratuity.percentage;
      } else {
        return false;
      }
    },
    fiveOrFive() {
      var subTotal = this.deepFind(
        this.$store,
        'state.cart.priceInfo.itemTotal.amount'
      );

      // logic of HUP-381
      // If subtotal is less than $100 default to $5 tip
      // if subtotal is greater than $100 defaut tip to 5%

      if (subTotal < 100) {
        return {
          amount: this.GRATUITY_DEFAULT,
          type: 'AMOUNT'
        };
      } else {
        return {
          amount: 5, // 5%
          type: 'PERCENTAGE'
        };
      }
    }
  },
  methods: {
    // Prevents user from typing in non-numbers with exception of .
    isNumber: function(evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    deepFind(obj, path) {
      var paths = path.split('.'),
        current = obj,
        i;

      for (i = 0; i < paths.length; ++i) {
        if (current[paths[i]] == undefined) {
          return undefined;
        } else {
          current = current[paths[i]];
        }
      }
      return current;
    },
    setGratuityFromDropdown(e) {
      if (e.target.value.includes('gratuity')) {
        // e.target.value is a string like 'gratuity5'
        this.setGratuityOption(e.target.value);
      } else {
        this.setGratuityOption('other');
      }
    },
    userChangedCustomAmount: function(e) {
      // This is where tofixed should happen
      var amount = e.target.value || e.target[0].value;
      if (amount > 1000 || amount < 0) {
        amount = this.fiveOrFive.amount;
        this.showInvalidTip = false;
      }

      var valueWithDecimals = (amount * 1).toFixed(2);
      this.inputBox = valueWithDecimals;
      this.setGratuityOption('other');
      // this.$store.commit('cart/SET_FRONTEND_GRATUITY', {type: 'AMOUNT', amount: valueWithDecimals})
    },
    postGratuity: function() {
      this.$store.dispatch('cart/POST_GRATUITY_AMOUNT', {
        type: this.type,
        amount: this.amount
      });
    },
    setGratuityOption(option, gratuityAmt) {
      var vm = this;

      switch (option) {
        case 'gratuity5':
          vm.type = 'PERCENTAGE';
          vm.amount = 5;
          this.$store.commit('cart/SET_FRONTEND_GRATUITY', {
            type: vm.type,
            amount: gratuityAmt
          });
          vm.showOther = false;
          break;
        case 'gratuity10':
          vm.type = 'PERCENTAGE';
          vm.amount = 10;
          this.$store.commit('cart/SET_FRONTEND_GRATUITY', {
            type: vm.type,
            amount: gratuityAmt
          });
          vm.selectedOption = 'gratuity10';
          vm.showOther = false;
          break;
        case 'gratuity15':
          vm.type = 'PERCENTAGE';
          vm.amount = 15;
          this.$store.commit('cart/SET_FRONTEND_GRATUITY', {
            type: vm.type,
            amount: gratuityAmt
          });
          // vm.selectedOption = 'gratuity15'
          vm.showOther = false;
          break;
        case 'other':
          // vm.selectedOption = 'other'
          vm.type = 'AMOUNT';
          vm.amount = parseFloat(vm.inputBox);
          vm.showOther = true;
          // this.$store.commit('cart/SET_FRONTEND_GRATUITY', {type: vm.type, amount: vm.amount})
          break;
        default:
      }

      this.postGratuity();
    }
    // roundHalfDown (amount) {
    //   return -Math.round(-amount)
    // }
  },
  mounted() {
    if (this.$store.state.cart.totalCommerceItemCount > 0) {
      var userAlreadySetGratuity = this.deepFind(
        this.$store,
        'state.cart.gratuity.amount'
      );

      if (typeof userAlreadySetGratuity === 'undefined') {
        // Set a default gratuity amount
        this.$store.dispatch('cart/POST_GRATUITY_AMOUNT', this.fiveOrFive);
      }
    } else {
      this.$router.push({ path: '/cart' });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../assets/lib';

@media screen and (max-width: 768px) {
  .gratuity-heading {
    display: none;
  }
}

.gratuity-heading {
  font-size: 14px;
  font-weight: bold;
  margin-right: 0.5rem; //footer
}

.gratuity-options {
  display: flex;
  justify-content: space-between;
  margin: 0 -2px 8px;
}

.gratuity-option {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #ccc;
  flex-basis: 100%;
  margin: 2px;
  height: 51px;
  padding: 0;
  justify-content: center;
  flex-grow: 1;
  flex-basis: 70px;
  min-width: 50px;
  box-shadow: none;
}

.gratuity-option--custom {
  background-color: transparent;
  justify-content: flex-end;
  text-align: center;
  padding-top: 12px;
  box-sizing: border-box;
  font-weight: 600;
}

.other-amount {
  font-size: 14px;
}

.gratuity-option:hover,
.gratuity-option:focus {
  color: $color-text-standard;
}

.gratuity-option.active,
.gratuity__custom.active .gratuity-option--custom {
  background-color: #f5fcf4;
  border-color: #036612;
}

.gratuity-percent-label {
  font-size: 10px;
  font-weight: normal;
}

.gratuity-custom-label {
  position: absolute;
  width: 100%;
  text-align: center;
  top: 8px;
}

.gratuity-dollar-label {
  font-size: 14px;
}

.gratuity__custom {
  display: flex;
  position: relative;
  flex-basis: auto;
  margin-bottom: 0;
  min-width: 85px;
}

.gratuity__custom--sidebar {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex-grow: 1;
}

.custom-gratuity-input {
  position: relative;

  button {
    position: absolute;
    right: 0;
    height: 100%;
  }
}

// text input box
.input-gratuity-custom__container {
  position: relative;
  display: inline-block;
}

.input-gratuity-custom__dollar {
  position: absolute;
  left: 12px;
  line-height: 46px;
}

.input-gratuity-custom {
  width: 100px;
  height: 42px;
  text-indent: 16px;
  margin-right: 0.5rem;
}

.gratuity-option--desktop-custom {
  width: 100%;
  height: 42px;
  text-indent: 16px;
}

.gratuity-option--desktop-custom.active {
  border-color: #036612;
  background-color: #f5fcf4;
}

.select-gratuity-dropdown {
  width: 80px;
  height: 42px;
}
</style>

<docs>
  User can enter a value between 0-1000
</docs>
